/**
 * Compact form of an email for tight UI slots (header pills, table cells):
 * "emailcool@mail.com" → "email...". The full address belongs in a tooltip
 * or detail row next to wherever this is rendered.
 */
export const truncateEmail = (email: string, visibleChars = 5): string => {
  const localPart = email.split("@")[0] ?? email;
  return `${localPart.slice(0, visibleChars)}...`;
};
